import { atom } from 'recoil';

// 主题模式
export const themeMode = atom<'light' | 'dark'>({
  key: 'themeMode',
  default: 'light',
});

export const globalFontSizeAtom = atom<number>({
  key: 'globalFontSize',
  default: 14,
});

/** 字号key */
export const globalFontSizeKeyAtom = atom<string>({
  key: 'globalFontSizeKey',
  default: '1', // 1 小号(正常) 2 中号(+2) 3 大号(+2)
});

export default themeMode;
